/**
 * @file Planboard grid drag component.
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { ElementRef, NgZone } from '@angular/core';
import { GridDragBaseComponent } from '../grid-drag-base/grid-drag-base.component';
import { AlertsService } from '../../core/alerts.service';
import { ExecutorsService } from '../executors.service';
import { DropTargetsService } from '../drop-targets.service';
import { LocalStorageService } from '../../core/local-storage.service';
import { GridService } from '../grid.service';
/** Planboard grid bar component. */
var PlanboardGridDragComponent = /** @class */ (function (_super) {
    tslib_1.__extends(PlanboardGridDragComponent, _super);
    /**
     * Constructs PlanboardGridDragComponent.
     * @param configurationsService The configuration service to get the configuration of this component.
     * @param router The router to synchronize query parameters with component state.
     */
    function PlanboardGridDragComponent(alertsService, executorsService, dropTargetsService, elementRef, ngZone, localStorageService, gridService) {
        var _this = _super.call(this, alertsService, executorsService, dropTargetsService, elementRef, ngZone, localStorageService, gridService) || this;
        /**
         * Gets, sets the selected Team of the planboard displayed.
         * This property is used to pass on the Team from
         * PlanboardGridComponent to planboard drag source components.
         * @type {Entity} The selected Team
         */
        _this.selectedTeam = null;
        return _this;
    }
    PlanboardGridDragComponent.prototype.afterInitialize = function () {
        _super.prototype.afterInitialize.call(this);
        if (!this.configuration || !this.configuration.components) {
            return;
        }
        var test = this.configuration.components.find(function (item) { return item.component.indexOf('PlanboardDragSourceTasksComponent') !== -1; });
        this.configTasksSource = test ? test.configuration : null;
        test = this.configuration.components.find(function (item) { return item.component.indexOf('PlanboardDragSourceAppointmentsComponent') !== -1; });
        this.configAppointmentsSource = test ? test.configuration : null;
        test = this.configuration.components.find(function (item) { return item.component.indexOf('PlanboardDragSourceServicesComponent') !== -1; });
        this.configServicesSource = test ? test.configuration : null;
        test = this.configuration.components.find(function (item) { return item.component.indexOf('PlanboardDragSourceAbsencesComponent') !== -1; });
        this.configAbsencesSource = test ? test.configuration : null;
    };
    return PlanboardGridDragComponent;
}(GridDragBaseComponent));
export { PlanboardGridDragComponent };
